import React from 'react';
import style from './TemplateSkeleton.module.css';

import {
	toCapitalCase,
} from '../../../../../Crow/Common/Crow';

class ListingColumnCheckbox extends React.Component {
	constructor(props) {
		super(props);

		// Convert the value to boolean if it's a number
		const booleanValue = this.convertToBoolean(props.value);
		
		this.state = {
			checked: booleanValue,
		};
	}

	convertToBoolean(value) {
		// Handle different input types and convert to boolean
		if (typeof value === 'boolean') {
			return value;
		}
		if (typeof value === 'number') {
			return value !== 0;
		}
		if (value === null || value === undefined) {
			return false;
		}
		return Boolean(value);
	}

	componentDidUpdate(prevProps) {
		// Follow the stored value when it changes underneath us (e.g. the post-save refetch).
		if (prevProps.value !== this.props.value) {
			const checked = this.convertToBoolean(this.props.value);
			if (checked !== this.state.checked) {
				this.setState({
					checked,
				});
			}
		}
	}

	updateFlatData(checked) {
		const {
			attr,
			flatData,
			listingColumnGroupKey,
			listingColumnKey,
			stateCallback,
		} = this.props;

		// Written immediately so a Save clicked right after the toggle includes it.
		if (!listingColumnKey) {
			flatData[listingColumnGroupKey][attr] = Boolean(checked);
		} else {
			flatData[listingColumnGroupKey][listingColumnKey][attr] = Boolean(checked);
		}
		stateCallback('flatData', flatData);
	}

	render() {
		const {
			attr,
			disabled,
			hint,
			label,
			listingColumnGroupKey,
			listingColumnKey,
		} = this.props;

		// Create a unique id for the input
		const inputId = listingColumnKey 
			? `${listingColumnGroupKey}-${listingColumnKey}-${attr}`
			: `${listingColumnGroupKey}-${attr}`;

		return (
			<div className={style.settingContainer}>
				<label className={style.settingLabel} htmlFor={inputId}>
					{label || toCapitalCase(attr)}
				</label>
				<input
					id={inputId}
					name={inputId}
					type="checkbox"
					disabled={Boolean(disabled)}
					title={hint}
					onChange={(e) => {
						if (disabled) {
							return;
						}
						const checked = e.target.checked;

						this.setState({
							checked: checked,
						});

						this.updateFlatData(checked);
					}}
					checked={disabled ? true : this.state.checked}
				/>
				{hint && <span className={style.settingHint}>{hint}</span>}
			</div>
		);
	}
}

export default ListingColumnCheckbox;